import $http from '../../axios-instance';
import Swal from "sweetalert2";

/**
 * Obtener empresas
 */
export async function obtenerEmpresas({commit, state}, nombre) {

  if (!state.cargando_datos_select && nombre && nombre.length > 1) {
    commit('establecerCargandoDatosSelect', true);

    let parametros = {
      params: {
        nombre: nombre
      }
    };

    await $http.get('/empresas/lista', parametros)
      .then((response) => {
        commit('establecerCargandoDatosSelect', false);
        commit('establecerEmpresas', response.data.data);
      })
      .catch(() => {
        commit('establecerCargandoDatosSelect', false);
      });
  }
}

/**
 * Obtener imágenes
 */
export async function obtenerImagenes({dispatch, commit}, perPage) {
  commit('setPorPagina', parseInt(perPage));
  await dispatch('obtenerImagenesHttp', true)
    .then(imagenes => commit('establecerImagenes', imagenes));
}

/**
 * Obtener imágenes por pagina
 */
 export async function obtenerImagenesPorPagina({dispatch, commit}, page) {
    commit('setPagina', parseInt(page));
    await dispatch('obtenerImagenesHttp', true)
      .then(imagenes => commit('establecerImagenes', imagenes));
  }

/**
 * Obtener imágenes banner
 */
export async function obtenerImagenesBanner({dispatch, commit, state}, id_empresa) {

  const id_empresa_actual = state.filtros.id_empresa;

  commit('estblacerIdEmpresaFiltros', id_empresa);

  await dispatch('obtenerImagenesHttp', false)
    .then(async (banners) => {

      commit('establecerImagenesBanner', banners);
      commit('setImageBannerActive', null);

      if (banners.length > 0) {
        const details = {
          companyId: id_empresa,
          bannerId: banners[0].id
        }
        await dispatch('bannerDetailsById', details);
      }
    });

  commit('estblacerIdEmpresaFiltros', id_empresa_actual);
}

/**
 * Obtener imágenes
 */
export async function obtenerImagenesHttp({commit, state, dispatch}, paginar) {

  commit('dashboard/load', true, {root: true});

  return await new Promise(async (resolve, reject) => {

    let parametros = {
      params: state.filtros
    };

    parametros.params.paginar = paginar;

    await $http.get('/empresas/banners', parametros)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        resolve(response.data.imagenes);
      })
      .catch(async () => {
        commit('dashboard/load', false, {root: true});
        await dispatch('mostrarMensaje', {icono: 'error', mensaje: error.message});
        reject([]);
      });
  });

}

/**
 * Obtener imagen
 */
export async function obtenerImagen({commit, state, dispatch}, imagen) {

  commit('dashboard/load', true, {root: true});
  await $http.get(`empresas/banners/${imagen.id}/${imagen.id_empresa}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('establecerModalImagen', true);
      commit('establecerImagen', response.data.imagen);
    })
    .catch(async () => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {icono: 'error', mensaje: error.message});
    });
}

/**
 * Guardar imagen
 */
export async function guardarImagen({commit, state, dispatch}) {

  commit('dashboard/load', true, {root: true});

  let form_data = new FormData();

  for (let i = 0; i < state.inputEmpresas.ids.length; i++) {
    form_data.append('id_empresas[]', state.inputEmpresas.ids[i]);
  }
  form_data.append('archivo', state.imagen.archivo);

  await $http.post('/empresas/banners', form_data)
    .then(async (response) => {
      commit('establecerModal', false);
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {icono: 'success', mensaje: response.data.message});
      commit('restablecerEmpresasCarga');
    })
    .catch(async (error) => {
      commit('dashboard/load', false, {root: true});

      let texto = [];

      if (error.errors) {
        const errores = error.errors;
        for (const llave in errores) {
          if (errores[llave] && errores[llave][0]) {
            texto.push(errores[llave][0]);
          }
        }
      }

      await dispatch('mostrarMensaje', {icono: 'error', mensaje: texto.join('\n')});
    });
}

/**
 * Cambiar estado imagen
 */
export async function cambiarEstado({commit, state, dispatch}, imagen) {

  await Swal.fire({
    title: 'Cambiar estado',
    text: "¿Está seguro de cambiar el estado de la imagen?",
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: 'Cancelar',
    confirmButtonText: 'Si'
  }).then(async (result) => {
    if (result.value) {

      commit('dashboard/load', true, {root: true});

      await $http.post(`empresas/banners/cambiar-estado/${imagen.id}/${imagen.id_empresa}`)
        .then(async (response) => {
          commit('dashboard/load', false, {root: true});
          await dispatch('mostrarMensaje', {icono: 'success', mensaje: response.data.message});
          dispatch('obtenerImagenes');
        })
        .catch(async (error) => {
          commit('dashboard/load', false, {root: true});
          await dispatch('mostrarMensaje', 'error', error.message);
        });
    }
  });
}

/**
 * Descargar imagen
 */
export async function descargarImagen({state, commit, dispatch}, imagen) {

  commit('dashboard/load', true, {root: true});

  await $http({
    url: `empresas/banners/descargar/${imagen.id}/${imagen.id_empresa}`,
    method: 'GET',
    responseType: 'blob'
  }).then(async (response) => {
    window.downloadFile(response.data,imagen.nombre_original)
    commit('dashboard/load', false, {root: true});
  }).catch(async (error) => {
    commit('dashboard/load', false, {root: true});
    await dispatch('mostrarMensaje', {icono: 'error', mensaje: 'Error al descargar la imagen'});
  });

}

export async function mostrarMensaje({}, {icono, mensaje}) {

  const titulo = icono === 'success' ? 'Muy bien!' : 'Error';

  await Swal.fire({
    position: 'center',
    icon: icono,
    title: titulo,
    text: mensaje,
    showConfirmButton: true,
    timer: 5000
  });
}

/**
 * Obtener empresas para la carga de imagenes
 */
 export async function obtenerEmpresasCarga({commit, state}, nombre) {

    if (nombre && nombre.length >= 3) {
      commit('dashboard/load', true, {root: true});

      let parametros = {
        params: {
          nombre: nombre
        }
      };

      await $http.get('/empresas/lista', parametros)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerEmpresasCarga', response.data.data);
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
        });
    }
  }

/**
* Banner - ver detalles del banner por id.
*
* @param params
* @returns {Promise<void>}
* @author Fernando Claros
*/
export async function bannerDetailsById({ commit }, {companyId, bannerId}) {

  commit('dashboard/load', true, { root: true });

  await $http.get(`banners/get-details/${companyId}/${bannerId}`)
    .then(({ data: response }) => {

      if (response.codeResonse == 200) commit('setImageBannerActive', response.banner);
      else {
        Swal.fire({
          position: 'center',
          icon: 'info',
          title: 'Banners',
          text: response.message,
          showConfirmButton: true,
          timer: 10000
        });
      }
    
    })
    .catch((error) => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Banners',
        text: response.message,
        showConfirmButton: true,
        timer: 10000
      });
    }).finally(() => commit('dashboard/load', false, { root: true }));
}
